module.exports = __webpack_public_path__ + "static/media/arrowLeft.0db9863c.svg";